import React, { Component } from 'react';
import Panel from '../../../../components/Panel';
import { Switch, Tabs, Tooltip } from 'antd';
import { RedoOutlined } from '@ant-design/icons';
import designConstructor from '../../../../services/helper/designConstructor';
import { createPortal } from 'react-dom';
import VirtualTable from '../../../../components/VirtualTable';
import { IMPEDANCE_LAYOUT_LIST } from '../../../../services/Cascade/constants';
import { POWER, SIGNAL } from '../../../../services/Designs/constants';
import { getNetExtensionData, getPortImpedanceNets } from '../../../../services/Cascade/Impedance';

const columns = [{
  title: 'Net',
  dataIndex: 'net',
  width: '80%'
}, {
  title: 'Type',
  dataIndex: 'type',
  width: '20%'
}
  // , {
  //   title: 'Impedance',
  //   dataIndex: 'impedance',
  //   width: '20%'
  // }
]

const SETTINGS = {
  minIndex: 0,
  startIndex: 0,
  itemHeight: 40,
  amount: 50,
  tolerance: 10
}

class PortImpedancePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      portImpedanceTable: {},
      portImpedance: {},
      activeKey: "",
      updateDataStatus: false
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount = () => {
    this.initColumns();
    this.initPortImpedanceTable();
  }

  closeModal = () => {
    this.props.closeModal(false);
  }

  initColumns = () => {
    columns[0].render = (text) => {
      return <div className='cascade-port-impedance-table-cell'>
        {text}
      </div>
    }

    columns[1].render = (text) => {
      return <div className='cascade-port-impedance-table-cell'>
        {text}
      </div>
    }

    columns[1].onCell = (record) => {
      return {
        record,
        edit: "select",
        options: [POWER, SIGNAL],
        dataIndex: "type",
        getPopupContainer: document.getElementById('cascade-port-impedance-dropdown'),
        handleSave: this.switchType,
      }
    }

    // columns[2].render = (text, record) => {
    //   const { portImpedance } = this.state;
    //   const { designId, type } = record;
    //   const { powerImpedance, signalImpedance, useNetImpedance } = portImpedance[designId] || {};
    //   const _impedance = type === POWER ? powerImpedance : signalImpedance
    //   const impedance = useNetImpedance ? text || _impedance : _impedance;
    //   return <div className={`cascade-port-impedance-table-cell`}>
    //     {useNetImpedance ? null : <div className='aurora-table-cell-disabled'></div>}
    //     {impedance}
    //   </div>
    // }

    // columns[2].onCell = (record) => {
    //   const { portImpedance } = this.state;
    //   const { designId, type } = record;
    //   const { powerImpedance, signalImpedance, useNetImpedance } = portImpedance[designId] || {};
    //   if (!useNetImpedance) {
    //     return {
    //       edit: false
    //     }
    //   }
    //   const _impedance = type === POWER ? powerImpedance : signalImpedance
    //   return {
    //     record,
    //     edit: true,
    //     dataIndex: 'impedance',
    //     handleSave: this.saveImpedanceValue,
    //     placeholder: _impedance
    //   }
    // }
  }

  initPortImpedanceTable = async () => {
    let portImpedanceTable = {}, portImpedance = {};
    const { layouts, defaultActiveKey } = this.props;
    for (let layout of layouts) {
      const { designId, type, portImpedanceNets = [], extraction = {} } = layout;
      if (![...IMPEDANCE_LAYOUT_LIST].includes(type)) {
        continue;
      }
      const { powerImpedance, signalImpedance, useNetImpedance } = extraction;

      portImpedanceTable[designId] = portImpedanceNets.sort((a, b) => a.type.localeCompare(b.type)) || [];
      portImpedance[designId] = { powerImpedance, signalImpedance, useNetImpedance };
    }
    const _defaultActiveKey = defaultActiveKey || Object.keys(portImpedanceTable)[0];
    this.setState({
      portImpedanceTable,
      portImpedance,
      activeKey: _defaultActiveKey,
    })
  }

  regenerateTable = () => {
    const { currentDesignId, layouts } = this.props;

    const netExtensionData = getNetExtensionData(layouts, currentDesignId)
    let portImpedanceTable = {}, portImpedance = {};
    for (let layout of layouts) {
      const { designId, type, portImpedanceNets = [], extraction = {}, powerDomains = [] } = layout;
      if (![...IMPEDANCE_LAYOUT_LIST].includes(type)) {
        continue;
      }
      const { powerImpedance = '0.1', signalImpedance = '50', useNetImpedance } = extraction;

      const _portImpedanceNets = getPortImpedanceNets(powerDomains, designId, portImpedanceNets, netExtensionData, type);
      layout.portImpedanceNets = _portImpedanceNets;

      portImpedanceTable[designId] = _portImpedanceNets.sort((a, b) => a.type.localeCompare(b.type)) || [];
      portImpedance[designId] = { powerImpedance, signalImpedance, useNetImpedance };
    }
    this.setState({
      portImpedanceTable,
      portImpedance,
      updateDataStatus: !this.state.updateDataStatus
    })
  }

  onChange = (activeKey) => {
    this.setState({
      activeKey
    });
  }

  closeModal = () => {
    const { portImpedanceTable } = this.state;
    this.props.updatePortImpedance(portImpedanceTable);
    this.props.closeModal(false);
  }

  saveImpedanceValue = (record) => {
    const { impedance, designId, net } = record;
    const { portImpedanceTable } = this.state;
    const portTable = portImpedanceTable[designId];
    const findIndex = portTable.findIndex(item => item.net === net);
    if (findIndex > -1) {
      portTable[findIndex].impedance = impedance;
      this.setState({
        portImpedanceTable: {
          ...portImpedanceTable,
          [designId]: [...portTable]
        },
        updateDataStatus: !this.state.updateDataStatus
      });
    }
  }

  switchType = (record) => {
    const { type, designId, net } = record;
    const { portImpedanceTable } = this.state;
    const portTable = portImpedanceTable[designId];
    const findIndex = portTable.findIndex(item => item.net === net);
    if (findIndex > -1) {
      portTable[findIndex].type = type;
      this.setState({
        portImpedanceTable: {
          ...portImpedanceTable,
          [designId]: [...portTable]
        },
        updateDataStatus: !this.state.updateDataStatus
      });
    }
  }

  changeSwitch = (checked) => {
    const { layouts } = this.props;
    const { portImpedance, activeKey } = this.state;
    this.setState({
      portImpedance: {
        ...portImpedance,
        [activeKey]: {
          ...portImpedance[activeKey],
          useNetImpedance: checked
        }
      }
    }, () => {
      const layout = layouts.find(item => item.designId === activeKey);
      if (layout) {
        const extraction = layout.extraction || {};
        this.props.saveConfig(activeKey, { ...extraction, useNetImpedance: checked }, false);
      }
    })
  }

  getPortImpedances = (portImpedanceTable) => {
    const keys = Object.keys(portImpedanceTable);
    let portImpedances = [];
    for (let key of keys) {
      const designName = designConstructor.getDesignName(key);
      portImpedances.push({
        key: key,
        label: designName,
        children: this.portTableRender(portImpedanceTable[key], key)
      });
    }
    return portImpedances
  }

  portTableRender = (dataSource, designId) => {
    // const { portImpedance } = this.state;
    // const { useNetImpedance } = portImpedance[designId] || {};
    return <div>
      {/* <div className="cascade-port-impedance-switch">
        Use single net impedance
        <Switch
          size="small"
          className="aurora-switch-small"
          checked={useNetImpedance}
          onChange={(e) => this.changeSwitch(e)}
        />
      </div> */}
      <VirtualTable
        rowKey="net"
        columns={columns}
        pagination={false}
        dataSource={dataSource.map(item => ({ ...item, designId }))}
        setting={{ ...SETTINGS, maxIndex: dataSource.length }}
        height={500}
        bordered
        size="small"
        scrollId={`virtual-table-scroll-${designId}`}
        updateDataStatus={this.state.updateDataStatus}
      />
    </div>
  }

  render() {
    const { portImpedanceTable, activeKey } = this.state;
    const portImpedances = this.getPortImpedances(portImpedanceTable)
    const content = (
      <Panel
        title={
          <span>
            Port Impedance Setup
            <Tooltip title="Regenerate table" classNames={{ root: 'aurora-tooltip' }}><RedoOutlined className='cascad-redo-icon' onClick={this.regenerateTable} /></Tooltip>
          </span>
        }
        className="cascade-port-impedance-panel"
        zIndex={2001}
        position='panel-center'
        width={800}
        maxWidth={1000}
        maxHeight={1000}
        draggable
        onCancel={this.closeModal}
      >
        <div>
          <Tabs
            activeKey={activeKey}
            className='cascade-port-impedance-tabs'
            items={portImpedances}
            onChange={this.onChange}
          />
        </div>
        <div id="cascade-port-impedance-dropdown"></div>
      </Panel>
    );
    return createPortal(content, this.dialogRoot)
  }
}

export default PortImpedancePanel;